import type { ReactNode } from 'react';

export const symbol_approval_delegation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m570-616 214-213q8-8 20-8t21 8q9 8 9 20.5t-9 21.5L591-552q-9 9-21 9t-21-9L427-674q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l100 100Zm32 506 248-78q0-20-15.5-34T798-235H589q-16 1-31.5-2t-30.5-8l-66-20q-12-4-18-16t-2-24q4-12 15.5-18t23.5-1l64 21q11 4 22.5 6t22.5 2h56q2 0 0 0 0-21-14-36.5T597-355l-218-83h-84v238l307 90Zm-13 57-294-84q-2 27-22.5 42T235-80h-95q-25 0-42.5-17.5T80-140v-298q0-25 17.5-42.5T140-498h238q5 0 10.5 1t10.5 3l218 82q42 16 66.5 46t24.5 71h90q51 0 86.5 37t35.5 88q0 11-5.5 20T899-138L623-53q-8 2-17 2t-17-2Zm-449-87h94v-298h-94v298Z"
		/>
	</svg>
);
